import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import redirector from "../../util/redirector";
import Button from "../common/Button";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";
import * as layoutActions from "../../actions/layoutActions";

class NietGevondenPage extends React.Component {
	componentDidMount() {
		this.props.loadLayout('');
	}

	render() {
		return (
			<Section>
				<Fieldset>
					<div className="jumbotron">
						<h1 style={{fontSize:'16px', fontWeight: '600'}}>404 pad niet gevonden.</h1>
					</div>
				</Fieldset>
				<Fieldset>
					<Button small style={{fontSize:'14px'}} onClick={redirector.goToHome} text="Ga terug" />
				</Fieldset>
				<Fieldset />
			</Section>
		);
	}
}

NietGevondenPage.propTypes = {
	loadLayout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadExceptionPageLayout, dispatch)
	};
}
export default connect(null, mapDispatchToProps)(NietGevondenPage);
